import { render, staticRenderFns } from "./EModalDuplicarAulaPolivalencia.vue?vue&type=template&id=5453ecac"
import script from "./EModalDuplicarAulaPolivalencia.vue?vue&type=script&lang=js"
export * from "./EModalDuplicarAulaPolivalencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports